
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Das Problem, das die Menschheit mit einigen Viren hat, besteht in deren grosser Veränderlichkeit. Grippeviren tauchen jeden Winter in einem bis zur Unkenntlichkeit umgeschneiderten Kleid auf, der Aids-Erreger HIV verändert sich so schnell, dass letztlich jeder Mensch ein eigenes Virus in sich trägt. Im Vergleich dazu scheint das neue Sars-CoV-2 – auch wenn man sich das angesichts seiner derzeit massiven Auswirkungen kaum vorstellen mag – geradezu ein Garant für Stabilität zu sein. `}<strong parentName="p">{`«Das Virus hat nur sehr wenige Mutationen auf seinem Weg um die Welt mitgemacht», sagt der Virologe Georg Bornkamm.`}</strong></p>
    <p>{`Bornkamm hat das Erbgut verschiedener Sars-CoV-2-Viren miteinander verglichen. Sie stammen von Patienten aus aller Welt und wurden von Wissenschaftlern auf der Plattform Gisaid geteilt. Demnach hat sich Sars-CoV-2 selbst nach seiner langen Reise von China bis in die USA gerade mal an etwa zehn Stellen in seinem Erbgut verändert, wie der Molekulargenetiker Peter Thielen von der Johns Hopkins University der Washington Post sagte. «Das ist eine relativ kleine Zahl von Mutationen dafür, dass das Virus eine so grosse Zahl von Menschen passiert hat. Das ist eine gute Nachricht. Die Stabilität des Virus lässt darauf hoffen, dass ein Impfstoff gegen Sars-CoV-2, wenn er denn entwickelt ist, über Generationen wirksam sein wird. Dies gilt seit langem für Impfstoffe gegen Masern, Keuchhusten und Röteln, während für das Influenzavirus jedes Jahr ein neuer Impfstoff her muss.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;